import { render, staticRenderFns } from "./historyChart.vue?vue&type=template&id=4c855eaa&scoped=true&"
import script from "./historyChart.vue?vue&type=script&lang=js&"
export * from "./historyChart.vue?vue&type=script&lang=js&"
import style0 from "./historyChart.vue?vue&type=style&index=0&id=4c855eaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c855eaa",
  null
  
)

export default component.exports